import IframeInnerLayer from '../layer/IframeInnerLayer';

/**
 * @export
 * @class KCAuthInfo
 * KC 인증 정보고시
 */
export default class KCAuthInfo {
  constructor() {
    // 필요 data 유효 확인
    const {
      additionalInfo,
      kcAuthInfoList,
      dealKind,
    } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    if (
      !additionalInfo &&
      Object.keys(additionalInfo).length < 1 &&
      !kcAuthInfoList &&
      Object.keys(kcAuthInfoList).length < 1
    ) {
      return;
    }

    // 베이직딜, OM딜인 경우 그림
    const bTargetDealKind = dealKind === 'OPEN_MARKET' || dealKind === 'BASIC';
    // kcAuthTarget - N(미해당), Y(해당), X(상세정보 참고)
    // kcAuthTarget이 1) X일때 그림,
    //               2) Y이고 kcAuthInfoList가 비어있지 않으면 그림
    const bRenderKCAuthInfo =
      additionalInfo &&
      (additionalInfo.kcAuthTarget === 'X' ||
        (additionalInfo.kcAuthTarget === 'Y' && kcAuthInfoList.length));
    if (!bTargetDealKind || !bRenderKCAuthInfo) {
      return;
    }

    this.welWrapper = $('#_wrapKCAuthInfo');

    this.oIframeInnerLayer = null;

    this.setEvent();
    this.render();
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton]', this.onClickToggle);
    // KC인증 레이어 열기 eventListener 등록
    this.welWrapper.on(
      'click',
      '[data-role=btnShowKCInfoLayer]',
      this.onClickShowKCInfoLayer
    );
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '[data-role=toggleButton]');
      this.welWrapper.off('click', '[data-role=btnShowKCInfoLayer]');
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    $(e.currentTarget).toggleClass('open');
  };

  /**
   * KC인증 레이어 열기 eventListener
   */
  onClickShowKCInfoLayer = e => {
    if (!this.oIframeInnerLayer) {
      this.oIframeInnerLayer = new IframeInnerLayer();
    }

    const kcAuthType = $(e.currentTarget).data('authType');
    const kcAuthNo = $(e.currentTarget).data('authNo');

    let src;
    if (kcAuthType === 'BC0001') {
      src = `https://www.tmon.co.kr/rrainfo/${kcAuthNo}/BC0001`;
    } else {
      src = `https://safetykorea.kr/search/searchPop?menu=search&certNum=${kcAuthNo}`;
    }

    this.oIframeInnerLayer.open({
      title: '인증현황 검색결과',
      src,
    });

    e.preventDefault();
  };

  render() {
    const {
      additionalInfo,
      kcAuthInfoList,
      importType,
      dealKind,
      deliveryInfo,
    } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    let sMarkType;
    let sImportType;
    let bAdditionalText;
    const noShowKcAuthNo = ['LV0004', 'ET0003', 'CH0003'];

    if (
      importType === 'B' ||
      (dealKind === 'OPEN_MARKET' &&
        deliveryInfo.deliveryProductType === 'DP03')
    ) {
      bAdditionalText = true;
      sImportType = '구매대행';
    } else if (importType === 'P') {
      bAdditionalText = true;
      sImportType = '병행수입';
    }

    const sHtml = `<div class="bx_ct">
                <div class="ct_wrp">
                    <button type="button" data-role="toggleButton" class="toggle tit_align_top ${'open'}">
                        <h4>KC인증 정보고시</h4>
                    </button>
                    <div class="ct slide-ct">
                        <div class="kc_mark_area">
                            ${
                              additionalInfo.kcAuthTarget === 'X'
                                ? '<div class="item kc_none"><div class="in"><div class="txt"><p>본 상품의 인증정보는 상품상세설명을 참조하시기 바랍니다.</p></div></div></div>'
                                : `<ul class="lst_kc">${
                                    kcAuthInfoList && kcAuthInfoList.length
                                      ? kcAuthInfoList
                                          .map(({option1, kcAuthType, title, kcAuthNo}) => {
                                            sMarkType =
                                              option1 &&
                                              typeof option1 === 'string'
                                                ? option1.toLowerCase()
                                                : '';
                                            const isNoShowKcAuthNo = noShowKcAuthNo.includes(kcAuthType);
                                            if (sMarkType === 'not_set') {
                                              sMarkType = '';
                                            }

                                            return `<li>
                                                        <div class="item">
                                                            <div class="in">
                                                                ${
                                                                  sMarkType
                                                                    ? `<div class="mark"><i class="${sMarkType}" /></div>`
                                                                    : ''
                                                                }
                                                                <div class="txt">
                                                                    <dl>
                                                                        <dt>${
                                                                          title
                                                                        }</dt>
                                                                        ${
                                                                          sMarkType && !isNoShowKcAuthNo
                                                                            ? `<dd>
                                                                                    인증번호 :
                                                                                    <button data-role="btnShowKCInfoLayer" data-auth-type="${kcAuthType}" data-auth-no="${kcAuthNo}"> ${kcAuthNo} </button>
                                                                                </dd>`
                                                                            : '<dd>본 상품의 인증정보는 상품상세설명을 참조하시기 바랍니다.</dd>'
                                                                        }
                                                                    </dl>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>`;
                                          })
                                          .join('')
                                      : ''
                                  }</ul>`
                            }
                            <p class="txt_fix">해당 인증 검사정보는 판매자가 직접 등록한 것으로 등록 정보에 대한 책임은 판매자에게 있습니다.</p>
                            ${
                              bAdditionalText
                                ? `<p class="txt_fix">이 제품은 ${
                                    sImportType === '구매대행'
                                      ? '구매대행을 통하여 유통되는'
                                      : '병행수입된'
                                  } 제품입니다.<br>
                                    이 제품은 「전기용품 및 생활용품 안전관리법」에 따른 안전관리대상 제품입니다.</p>`
                                : ''
                            }
                        </div>
                    </div>
                </div>
            </div>`;

    this.welWrapper.html(sHtml);
  }
}
